import { IModel } from "@/@types/models/model";
import { coreFields } from "./helpers/coreFields";

const ZKVlasnik: IModel = {
  title: "Vlasnici",
  apiPath: "data/dkp/{dkp_id}/zk-vlasnici/",
  forms: {
    "default": {
      fields: ["id"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "vl", "udio", "naziv", "adresa", "oib", "opis_etaze"],
      hidden: ["opis_etaze"]
    }
  },
  fields: [
    coreFields.id,
    { 
      title: "Vlasnicki list ID",
      source: "vl",
      ttoken: "vlasnici.vlasnicki_list",
      type: "wholenum",
      readonly: true
    },
    { 
      title: "Udio",
      source: "udio",
      ttoken: "vlasnici.udio",
      type: "text",
      readonly: true
    },
    { 
      title: "Naziv",
      source: "naziv",
      ttoken: "vlasnici.naziv",
      type: "text",
      readonly: true
    },
    { 
      title: "Adresa",
      source: "adresa",
      ttoken: "vlasnici.adresa",
      type: "text",
      readonly: true
    },
    { 
      title: "OIB",
      source: "oib",
      ttoken: "common.oib",
      type: "text",
      readonly: true
    },
    { 
      title: "Vlasnički list",
      source: "ko_pl",
      ttoken: "vlasnici.vlasnicki_list",
      type: "text",
      readonly: true
    },
    { 
      title: "Katastarska općina",
      source: "ko",
      ttoken: "vlasnici.katastarska_opcina",
      type: "text",
      readonly: true
    },
    { 
      title: "Opis etaže",
      source: "opis_etaze",
      ttoken: "vlasnici.opis_etaze",
      type: "text",
      readonly: true
    }
  ]
}

export default ZKVlasnik;
